export const faqData = [
  {
    question: `Are Chinese Herbs Safe To Consume?`,
    answer: `When prescribed by a licensed practitioner, and taken as advised, Chinese herbs are safe. All of our practitioners are licensed to prescribe Chinese herbs and have been educated in the pharmacological attributes of chinese medicinals to avoid drug-herb interactions. A licensed practitioner can make sure that the herbal formulas that are being prescribed do not interact with western medicinals.`,
  },
  {
    question: `Can I Take My Herbs On An Empty Stomach?`,
    answer: `You can take herbs on an empty stomach. If you notice discomfort, consult with your practitioner.`,
  },
  {
    question: `Can I Take Vitamins And Other Supplements While I Take My Herbs?`,
    answer: `It is usually not a problem, but we advise you check with your practitioner. For best absorption, be sure to take your supplements and herbs one hour apart.`,
  },
  {
    question: `How Long Do Cooked Herbal Formulas Last?`,
    answer: `Once the tea is cooked it is only good for 1 week in the refrigerator.`,
  },
  {
    question: `I Am Experiencing Abdominal Pain And Bloating After Taking My Herbs. Is This Normal? What Should I Do?`,
    answer: `Tell your practitioner about your symptoms. Some experience digestive upset during the first few doses of herbs, and then symptoms usually subside.`,
  },
  {
    question: `What Should I Do If I Forget To Drink My Tea For One Dose?`,
    answer: `Do not double up the next dose. For optimal results, do your best to stay on schedule.`,
  },
  {
    question: `I Over-Cooked My herbal Tea And Only Have One Cup? Is It Still Good?`,
    answer: `Overcooking is not a problem, so long as the tea is not burned. If you have one concentrated cup of herbal tea, add three cups of warm filtered water to dilute it.`,
  },
  {
    question: `I Take Medication. Is It Safe To Also Take Chinese Herbs?`,
    answer: `Few medications are incompatible with Chinese Herbs. It is important to tell your practitioner of all medications you are on, so they may determine if Chinese herbs are right for you.`,
  },
  {
    question: `What Is A Chinese Herbal Formula?`,
    answer: `Chinese herbs consist of dried plant, mineral, and animal products that are combined in a formula to work synergistically to treat an ailment. Chinese herbs are rarely used individually. When boiled at a certain temperature, the phytochemicals in the herbs interact to produce the desired medicine. Each formula is custom tailored to fit the patient’s needs. The herbs are soaked and cooked in water, then strained and served warm as a medicinal tea. Chinese herbal formulas are also available in pill and granular/powder form.`,
  },
  {
    question: `What Is The Difference Between A Raw Herbal Formula And A Granular Herbal Formula?`,
    answer: `A raw herbal formula requires that the ingredients be soaked, then cooked in water and strained before they are ready to consume. A granular formula is one in which the herbs have already been soaked, cooked, strained and then dried into a granular-like powder. To prepare a granular formula, the powder is simply dissolved into a cup of hot water and consumed.`,
  },
];
